import { render } from "./HelpAgency.vue?vue&type=template&id=242e2935&scoped=true"
import script from "./HelpAgency.vue?vue&type=script&lang=js"
export * from "./HelpAgency.vue?vue&type=script&lang=js"

import "./HelpAgency.vue?vue&type=style&index=0&id=242e2935&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242e2935"]])

export default __exports__